import * as React from 'react';
import { ReactComponent as UploadIconSVG } from '../../assets/icons/upload.svg';
import IconPattern, { IconProps } from './_IconPattern';

const UploadIcon: React.FunctionComponent<IconProps> = (props) => {
  return <IconPattern component={UploadIconSVG} variantPlaces={1} {...props} />;
};

export default UploadIcon;
